import Vue from 'vue';
import VopsUI from '@eventbooking/vops-ui';

Vue.use(VopsUI);

export default new VopsUI();